import React from "react";
import { Building2, ArrowRight, Clock, ExternalLink } from "lucide-react";
import { EvidenceTag, OutcomeBadge } from "./Badges";
import { ScoreRing } from "./Similarity";

function MetricList({ items }) {
  if (!items || !items.length) return <span className="text-xs text-slate-400">No data</span>;
  return (
    <div className="space-y-1.5">
      {items.map((m, i) => (
        <div key={i} className="flex items-start justify-between gap-2">
          <span className="text-xs text-slate-500">{m.label}</span>
          <span className="flex items-center gap-1.5">
            <span className="font-mono text-xs font-medium text-slate-900">{m.value}</span>
            <EvidenceTag type={m.type} />
          </span>
        </div>
      ))}
    </div>
  );
}

export function CaseCard({ c, onOpen, index }) {
  return (
    <div
      data-testid={`case-card-${index}`}
      className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 cursor-pointer"
      onClick={() => onOpen(c)}
    >
      <div className="flex items-start justify-between gap-4 mb-4">
        <div className="flex items-start gap-3 min-w-0">
          <div className="w-9 h-9 rounded-lg bg-slate-900 flex items-center justify-center shrink-0">
            <Building2 className="w-4 h-4 text-white" />
          </div>
          <div className="min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <h4 className="font-semibold text-slate-900 leading-tight">{c.company}</h4>
              {c.is_demo && (
                <span className="font-mono text-[10px] font-semibold px-1.5 py-0.5 rounded bg-amber-100 text-amber-800 border border-amber-200">DEMO DATA</span>
              )}
            </div>
            <p className="text-xs text-slate-500 mt-0.5">{c.industry} • {c.market} • {c.size}</p>
          </div>
        </div>
        <div className="flex flex-col items-center gap-1 shrink-0">
          <ScoreRing value={c.similarity?.overall} />
          <span className="text-[10px] uppercase tracking-wide text-slate-400">match</span>
        </div>
      </div>

      <div className="mb-4">
        <span className="text-[10px] uppercase tracking-wider text-slate-400 font-medium">Their decision</span>
        <p className="text-sm text-slate-700 mt-1 leading-relaxed">{c.their_decision}</p>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-4 pt-4 border-t border-slate-100">
        <div>
          <span className="text-[10px] uppercase tracking-wider text-slate-400 font-medium">Before</span>
          <div className="mt-2"><MetricList items={c.before} /></div>
        </div>
        <div>
          <span className="text-[10px] uppercase tracking-wider text-slate-400 font-medium">After</span>
          <div className="mt-2"><MetricList items={c.after} /></div>
        </div>
      </div>

      <div className="flex items-center justify-between pt-4 border-t border-slate-100">
        <div className="flex items-center gap-3">
          <OutcomeBadge value={c.outcome_category} />
          <span className="flex items-center gap-1 text-xs text-slate-500">
            <Clock className="w-3 h-3" /> {c.timeframe}
          </span>
        </div>
        <span className="flex items-center gap-1 text-xs font-medium text-slate-900">
          Full analysis <ArrowRight className="w-3.5 h-3.5" />
        </span>
      </div>
    </div>
  );
}
